// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"148ef5c4","239":"747695e4","453":"4f245ff9","732":"5d772afc"}[chunkId] + ".chunk.js";
};